const array = [
  {
    path: '/administrador/eventos',
    name: 'events_plataforma',
    props: true,
    component: () => import('./pages/events.vue'),
    meta: {
      layout: 'admin',
      requiresAuth: true,
      pageTitle: 'Eventos',
      breadcrumb: [
        {
          text: 'Eventos',
          active: true,
        },
      ],
    },
  }
]

export default array
